import { IconButton, MenuItem, TextField, Tooltip } from '@mui/material'
import { useStyles } from '../LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformationStyles'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import DateInput from '../LTLandVolumeTLPages/DateInput';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../setup/redux/RootReducer';
import TimeInput from '../TimeInput/TimeInput';
import moment from 'moment';
import { stylesMUIInput } from '../stylesMUIInput';
import AppointmentModal from './AppointmentModal';

const PickupAndDelivery = ({date, handleChange, setDataFormik, error, values, formik, touched, setTouched, formikDispatch, dispatchShip, formDisabled, setEditErrorModal, hasAppointmentAccessorial}: any) => {
    const classes = useStyles({props: {}})
    const tracking = useSelector<RootState>(({pages}) => pages.tracking) as any
    const [time, setTime] = useState({             
        from: null,     
        to: null
    })
    const [errorLocal, setErrorLocal] = useState({
        from: false,
        to: false
    })
    const resetValues = useSelector<RootState>(({pages}) => pages?.resetValues) as boolean
    const newBookingValues = useSelector<RootState>(({pages}) => pages.newBookingValues) as any
    const quoteValues = useSelector<RootState>(({pages}) => pages.quoteValues) as quoteValuesModel
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    
    const [openApptModal, setOpenApptModal] = useState(false)

    const fieldPrefix = date === 'Pickup' ? 'pickupDate' : 'deliveryDate'
    const apptValues = formik.values[fieldPrefix]
    // Filter out "empty" time values like "0000", "00:00" that the backend may return
    const isValidTime = (val: any) => val && val !== '0000' && val !== '00:00' && val !== '00:00:00'
    const hasApptData = !!(
        apptValues?.appointmentDate ||
        isValidTime(apptValues?.appointmentTime) ||
        apptValues?.appointmentNumber ||
        apptValues?.appointmentContact ||
        apptValues?.appointmentNotes
    )

    useEffect(() => {
        if (hasAppointmentAccessorial === false && hasApptData) {
            formik.setFieldValue(`${fieldPrefix}.appointmentNeeded`, false)
            formik.setFieldValue(`${fieldPrefix}.appointmentDate`, null)
            formik.setFieldValue(`${fieldPrefix}.appointmentTime`, null)
            formik.setFieldValue(`${fieldPrefix}.appointmentNumber`, '')
            formik.setFieldValue(`${fieldPrefix}.appointmentContact`, '')
            formik.setFieldValue(`${fieldPrefix}.appointmentNotes`, '')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasAppointmentAccessorial])

    const menuProps = {
        classes: {
            list: classes.selectPaperList
        }
    }

    const dateStringToTimeStamp = (dateString) => {
        let hoursAndMinutes = dateString?.split(":")
        let currentDate = null
        let hour = null

        if(hoursAndMinutes?.length === 2){
            currentDate = new Date()
            currentDate.setHours(parseInt(hoursAndMinutes[0]), parseInt(hoursAndMinutes[1]), 0)
            hour = currentDate.getTime()
        }else{
            currentDate = null
        }

        return hour
    }

    useEffect(() => {
        let hourFrom = dateStringToTimeStamp(values?.from)
        let hourTo = dateStringToTimeStamp(values?.to)
        
        if(hourTo && hourFrom && (hourTo < hourFrom)){
            setErrorLocal({
                ...errorLocal,
                to: true
            })
            formik.setFieldError(`${date.toLowerCase()}Date.to`, 'Must be after from')
        }else{
            setErrorLocal({
                ...errorLocal,
                to: false
            })
            formik.setFieldError(`${date.toLowerCase()}Date.to`, '')
        }

        if(!values.from && !values.to){
            setTime({
                to: null,
                from: null,
            })
            setErrorLocal({
                to: false,
                from: false,
            })
        }else if(!values.from){
            setTime({
                ...time,
                from: null,
            })
            setErrorLocal({
                ...errorLocal,
                from: false,
            })
        }else if(!values.to){
            setTime({
                ...time,
                to: null,
            })
            setErrorLocal({
                ...errorLocal,
                to: false,
            })
        }
    }, [values.from, values.to])

    useEffect(() => {
        if(date === 'Pickup'){ 
            setTime({
                from: formik.values?.pickupDate?.from ? moment(formik.values?.pickupDate?.from, "HH:mm") : null,
                to: formik.values?.pickupDate?.to ? moment(formik.values?.pickupDate?.to, "HH:mm") : null
            })
        }else{
            setTime({
                from: formik.values?.deliveryDate?.from ? moment(formik.values?.deliveryDate?.from, "HH:mm") : null,
                to: formik.values?.deliveryDate?.to ? moment(formik.values?.deliveryDate?.to, "HH:mm") : null
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.pickupDate, formik.values?.deliveryDate])

    useEffect(() => {
        if(!quoteValues.length){
            if(date === 'Pickup'){
                setTime({
                    from: newBookingValues?.pickupDate?.from ? moment(newBookingValues?.pickupDate?.from, "HH:mm") : null,
                    to: newBookingValues?.pickupDate?.to ? moment(newBookingValues?.pickupDate?.to, "HH:mm") : null
                })
            }else{
                setTime({
                    from: newBookingValues?.deliveryDate?.from ? moment(newBookingValues?.deliveryDate?.from, "HH:mm") : null,
                    to: newBookingValues?.deliveryDate?.to ? moment(newBookingValues?.deliveryDate?.to, "HH:mm") : null
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newBookingValues, resetValues])

    useEffect(() => {
        if(isNaN(formik?.values?.pickupDate?.date)){
            formik.setFieldError('pickupDate.date', 'must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).')
        }else{
            formik.setFieldError('pickupDate.date', '')
        }

        if(isNaN(formik?.values?.deliveryDate?.date)){
            formik.setFieldError('deliveryDate.date', 'must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).')
        }else{
            formik.setFieldError('deliveryDate.date', '')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.pickupDate.date, formik.values.deliveryDate.date])

    useEffect(() => {
        if(tracking.length !== 0){
            if(date === 'Pickup'){
                setTime({
                    from: tracking?.pickupDate?.from ? moment(tracking?.pickupDate?.from, "HH:mm") : null,
                    to: tracking?.pickupDate?.to ? moment(tracking?.pickupDate?.to, "HH:mm") : null
                })
            }else{
                setTime({
                    from: tracking?.deliveryDate?.from ? moment(tracking?.deliveryDate?.from, "HH:mm") : null,
                    to: tracking?.deliveryDate?.to ? moment(tracking?.deliveryDate?.to, "HH:mm") : null
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tracking])

    let errorLet = error?.date ? error?.date : (formikDispatch?.errors[`${date.toLowerCase()}Date`]?.date && dispatchShip) ? formikDispatch?.errors[`${date.toLowerCase()}Date`]?.date : ''
    let touchedLet = touched[date.toLowerCase()] || dispatchShip

    return (
        <>
            <div className={`row mt-4 mt-sm-0`}>
                <div className="col-6 col-sm-3 d-flex align-items-center">
                    {date === 'Pickup'
                        ? <WarehouseOutlinedIcon sx={{ color: '#009ef7', fontSize: fontSize !== 13 ? `${fontSize + 4}px` : '18px', mr: 0.5 }} />
                        : <LocalShippingOutlinedIcon sx={{ color: '#009ef7', fontSize: fontSize !== 13 ? `${fontSize + 4}px` : '18px', mr: 0.5 }} />
                    }
                    <TextField
                        disabled={newBookingValues.dispatched}
                        select
                        label=" "
                        value={values.type || ""}
                        onChange={handleChange}
                        name={`${date.toLowerCase()}Date.type`}
                        className={classes.selectMUI}
                        InputProps={{
                            style: stylesMUIInput(fontSize),
                            readOnly: formDisabled
                        }}
                        SelectProps={{
                            IconComponent: KeyboardArrowDownIcon,
                            MenuProps: menuProps
                        }}
                        InputLabelProps={{shrink: false}}
                        onClick={() => {
                            if(formDisabled){
                                setEditErrorModal(true)
                            }
                        }}
                    >
                        <MenuItem value={`${date}On`}>{date} On</MenuItem>
                        <MenuItem value={`${date}By`}>{date} By</MenuItem>
                    </TextField>
                </div>
                <div className="col-6 col-sm-3">
                    <div>
                        {/* ver {formik?.errors ? JSON.stringify(formik?.errors?.pickupDate) : 'sin errores'} */}
                        <DateInput
                            setDataFormik={setDataFormik}
                            pickupDate={values?.date}
                            // error={error?.date ? error?.date : (formikDispatch?.errors[`${date.toLowerCase()}Date`]?.date && dispatchShip) ? formikDispatch?.errors[`${date.toLowerCase()}Date`]?.date : ''}
                            error={formik?.errors[`${date.toLowerCase()}Date`]?.date && formik?.touched[`${date.toLowerCase()}Date`]?.date ? formik?.errors[`${date.toLowerCase()}Date`]?.date : ''}
                            touched={touched[date.toLowerCase()] || dispatchShip}
                            // touched={formik?.touched?.pickupDate?.date || touched[date.toLowerCase()] || dispatchShip}
                            setTouched={(boolean) => setTouched({...touched, [date.toLowerCase()]: boolean})}
                            name={`${date.toLowerCase()}Date.date`}
                            allowPastDates={true}
                            minDate={date === 'Delivery' ? formik.values?.deliveryDateAllowed : null}
                            formDisabled={formDisabled}
                            setEditErrorModal={setEditErrorModal}
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-6 d-flex align-items-center mt-2 mt-sm-0">
                    <div className='me-2'>From</div>
                    <TimeInput
                        error={error?.from ? error?.from : (formikDispatch?.errors[`${date.toLowerCase()}Date`]?.from && dispatchShip) ? formikDispatch?.errors[`${date.toLowerCase()}Date`]?.from : ''}
                        data={time?.from}
                        setData={(value) => setTime({...time, from: value})}
                        name={`${date.toLowerCase()}Date.from`}
                        setFormikData={formik.setFieldValue}
                        className="me-4 normalFont"
                        errorLocal={errorLocal}
                        setErrorLocal={setErrorLocal}
                        time='from'
                        formDisabled={formDisabled}
                        setEditErrorModal={setEditErrorModal}
                    />
                    <div className='me-2'>To</div>
                    <TimeInput
                        error={error?.to ? error?.to : (formikDispatch?.errors[`${date.toLowerCase()}Date`]?.to && dispatchShip) ? formikDispatch?.errors[`${date.toLowerCase()}Date`]?.to : ''}
                        data={time?.to}
                        setData={(value) => setTime({...time, to: value})}
                        name={`${date.toLowerCase()}Date.to`}
                        setFormikData={formik.setFieldValue}
                        errorLocal={errorLocal}
                        setErrorLocal={setErrorLocal}
                        time='to'
                        formDisabled={formDisabled}
                        setEditErrorModal={setEditErrorModal}
                    />
                    {hasAppointmentAccessorial !== undefined && (
                        <Tooltip
                            title={
                                !hasAppointmentAccessorial
                                    ? `Add ${date.toLowerCase()} appointment accessorial to enable`
                                    : hasApptData
                                        ? `${date} appointment scheduled — click to edit`
                                        : `Schedule ${date.toLowerCase()} appointment`
                            }
                            arrow
                            placement="top"
                        >
                            <span className="ms-2">
                                <IconButton
                                    size="small"
                                    disabled={!hasAppointmentAccessorial}
                                    onClick={() => setOpenApptModal(true)}
                                    sx={{
                                        width: 28,
                                        height: 28,
                                        border: '1.5px solid',
                                        borderColor: hasApptData ? '#22c55e' : '#009ef7',
                                        borderRadius: '6px',
                                        color: hasApptData ? '#16a34a' : '#009ef7',
                                        backgroundColor: hasApptData ? '#f0fdf4' : '#fff',
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            backgroundColor: hasApptData ? '#22c55e' : '#009ef7',
                                            color: '#fff',
                                            boxShadow: hasApptData
                                                ? '0 2px 8px rgba(34,197,94,0.3)'
                                                : '0 2px 8px rgba(0,158,247,0.3)',
                                        },
                                        '&.Mui-disabled': {
                                            borderColor: '#d4dde6',
                                            backgroundColor: '#f4f6f8',
                                            color: '#c0c8d0',
                                        },
                                    }}
                                >
                                    {(hasApptData && hasAppointmentAccessorial)
                                        ? <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
                                        : <EventAvailableIcon sx={{ fontSize: 16 }} />
                                    }
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}
                </div>
            </div>
            <div className='row d-none d-sm-flex'>
                <div className="col-6 col-sm-3"></div>
                <div className="col-6 col-sm-3">
                    {(errorLet && touchedLet) && <small className="text-danger ms-1">
                        {errorLet.includes('must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).') && 'Invalid date'}
                        {errorLet === 'Pickup date cannot be in the past' && errorLet}
                        {!values?.date && 'Required'}
                    </small>}
                </div>
                <div className="col-3">
                    <small className="text-danger" style={{marginLeft: 43}}>{((error?.from ? error?.from : (formikDispatch?.errors[`${date.toLowerCase()}Date`]?.from && dispatchShip) ? formikDispatch?.errors[`${date.toLowerCase()}Date`]?.from : '') || errorLocal?.from) && 'Invalid time'}</small>
                </div>
                <div className="col-3">
                    <small className={`${error?.to === 'Must be after from' ? 'd-md-flex d-lg-flex justify-content-md-end justify-content-lg-start' : ''} text-danger`} style={{marginLeft: window.innerWidth < 1500 ? 0 : 33}}>{((error?.to ? error?.to : (formikDispatch?.errors[`${date.toLowerCase()}Date`]?.to && dispatchShip) ? formikDispatch?.errors[`${date.toLowerCase()}Date`]?.to : '') || errorLocal?.to) && (error?.to === 'Must be after from' ? error?.to : 'Invalid time')}</small>
                </div>
            </div>
            <AppointmentModal
                open={openApptModal}
                setOpen={setOpenApptModal}
                type={date}
                formik={formik}
                formDisabled={formDisabled}
            />
        </>
    )
}

export default PickupAndDelivery